<template>
  <ConversationSimulateLeft />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
